import React from 'react';
import { useQuickActions } from '../../../../hooks/useQuickActions';

interface QuickActionsTranslationProps {
  language: {
    label: string;
  };
  formData: string[];
  onChange: (data: string[]) => void;
}

export function QuickActionsTranslation({ language, formData, onChange }: QuickActionsTranslationProps) {
  const { actions } = useQuickActions();

  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-4">
        {actions.map((action, index) => (
          <div key={index} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
            {action.text}
          </div>
        ))}
      </div>
      <div className="space-y-4">
        {actions.map((action, index) => (
          <div key={index}>
            <input
              type="text"
              value={formData[index] || ''}
              onChange={(e) => {
                const newQuickActions = [...formData];
                newQuickActions[index] = e.target.value;
                onChange(newQuickActions);
              }}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder={`Quick action in ${language.label}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}